module.exports = __webpack_public_path__ + "img/Group 10177.c29d3fb2.svg";